import apiClient from './client';
import { API_ENDPOINTS } from './endpoints';

export interface DashboardStats {
  users: number;
  companies: number;
  devices: number;
  active_sessions: number;
  online_devices: number;
  offline_devices: number;
  maintenance_devices: number;
  total_sessions: number;
}

export const statsApi = {
  getDashboard: async (): Promise<DashboardStats> => {
    const response = await apiClient.get(API_ENDPOINTS.STATS);
    return response.data;
  },
};
